import {LINKS} from '@/links';

import {TOKEN_ERRORS} from '../../errors';

export function getRedirectUrl(email?: string | null): string {
    const emailQueryParam = email ? `&email=${window.encodeURIComponent(email)}` : '';
    return `${LINKS.login}?${emailQueryParam}&message=${TOKEN_ERRORS.USER_ALREADY_ACTIVATED}`;
}
